/**
 * Shared utility functions for component transformers
 */

// Default icon mappings for benefits
export const BENEFIT_ICON_MAP: Record<string, string> = {
  medical_expenses: "💊",
  trip_cancellation: "✈️",
  baggage_loss: "🧳",
  personal_liability: "🛡️",
  trip_delay: "⏱️",
  passport_loss: "📄",
  default: "✅",
};
